function initCards() {
  const cards = document.querySelectorAll(".our-employes .employe-card");
  const btn = document.querySelector(".show-more");

  // reset
  cards.forEach((c) => (c.style.display = ""));
  if (btn) btn.remove();

  if (window.matchMedia("(min-width: 768px)").matches && cards.length > 3) {
    cards.forEach((card, index) => {
      if (index >= 3) card.style.display = "none";
    });

    const button = document.createElement("button");
    button.textContent = "Ukázat další";
    button.className = "btn btn-secondary show-more";
    button.addEventListener("click", () => {
      cards.forEach((card) => (card.style.display = ""));
      button.remove();
    });

    document.querySelector(".our-employes").appendChild(button);
  }
}

document.addEventListener("DOMContentLoaded", initCards);
window.addEventListener("resize", initCards);
